<template>
  <div id="app">
    <app-header></app-header>
    <router-view/>
  </div>
</template>

<script>
import auth from '@/auth';

import AppHeader from '@/components/layout/Header.vue';

export default {
  mounted() {
    auth.on('stateChanged', (user) => {
      if (user) {
        this.$store.dispatch('signedIn', user);
      }
    });
  },

  components: {
    AppHeader,
  },
};
</script>

<style lang="scss">
* {
  box-sizing: border-box;
}
a {
  color: inherit;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
